"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Identity", {
  enumerable: true,
  get: function get() {
    return _Identity["default"];
  }
});
Object.defineProperty(exports, "Channel", {
  enumerable: true,
  get: function get() {
    return _Channel["default"];
  }
});
Object.defineProperty(exports, "RuleSet", {
  enumerable: true,
  get: function get() {
    return _RuleSet["default"];
  }
});
exports.createChannel = exports.createIdentity = exports.loadChannel = exports.loadIdentity = void 0;

var _Identity = _interopRequireDefault(require("./Identity"));

var _Channel = _interopRequireDefault(require("./Channel"));

var _RuleSet = _interopRequireDefault(require("./RuleSet"));

var loadIdentity = _Identity["default"].open;
exports.loadIdentity = loadIdentity;
var createIdentity = _Identity["default"].create;
exports.createIdentity = createIdentity;
var loadChannel = _Channel["default"].load;
exports.loadChannel = loadChannel;
var createChannel = _Channel["default"].create;
exports.createChannel = createChannel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJsb2FkSWRlbnRpdHkiLCJJZGVudGl0eSIsIm9wZW4iLCJjcmVhdGVJZGVudGl0eSIsImNyZWF0ZSIsImxvYWRDaGFubmVsIiwiQ2hhbm5lbCIsImxvYWQiLCJjcmVhdGVDaGFubmVsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFFQSxJQUFNQSxZQUFZLEdBQUdDLHFCQUFTQyxJQUE5Qjs7QUFDQSxJQUFNQyxjQUFjLEdBQUdGLHFCQUFTRyxNQUFoQzs7QUFFQSxJQUFNQyxXQUFXLEdBQUdDLG9CQUFRQyxJQUE1Qjs7QUFDQSxJQUFNQyxhQUFhLEdBQUdGLG9CQUFRRixNQUE5QiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBJZGVudGl0eSBmcm9tICcuL0lkZW50aXR5JztcbmltcG9ydCBDaGFubmVsIGZyb20gJy4vQ2hhbm5lbCc7XG5pbXBvcnQgUnVsZVNldCBmcm9tICcuL1J1bGVTZXQnO1xuXG5jb25zdCBsb2FkSWRlbnRpdHkgPSBJZGVudGl0eS5vcGVuO1xuY29uc3QgY3JlYXRlSWRlbnRpdHkgPSBJZGVudGl0eS5jcmVhdGU7XG5cbmNvbnN0IGxvYWRDaGFubmVsID0gQ2hhbm5lbC5sb2FkO1xuY29uc3QgY3JlYXRlQ2hhbm5lbCA9IENoYW5uZWwuY3JlYXRlO1xuXG5leHBvcnQge1xuICBDaGFubmVsLFxuICBJZGVudGl0eSxcbiAgUnVsZVNldCxcbiAgbG9hZElkZW50aXR5LFxuICBsb2FkQ2hhbm5lbCxcbiAgY3JlYXRlSWRlbnRpdHksXG4gIGNyZWF0ZUNoYW5uZWwsXG59O1xuIl19